export default __webpack_public_path__ + "static/media/CircleRed.6abe60b6.svg";